/* eslint-disable max-len */
export default {
    emailAlertBiz: {
        common: {
            emailAutoComplete: {
                sendToTip: "Enter the recipient's email address(es). For multiple, add one per line.",
                addEmail: 'Email:',
                single: 'Individual',
                team: 'Team',
                teamManage: 'Manage my teams',
                teamCount: '{count} team members',
                noMatchedTeam: 'No matching teams found',
                noMatchedSingle: 'No matching email accounts found',
                includeExternal: 'External',
            },
            alertFrequency: {
                weekly: 'Weekly',
                monthly: 'Monthly',
                everyday: 'Everyday',
                weekdays: [
                    null,
                    'Monday',
                    'Tuesday',
                    'Wednesday',
                    'Thursday',
                    'Friday',
                    'Saturday',
                    'Sunday',
                ],
                date: '{n}{fix}',
                lastDay: 'the last day',
            },
            alertDialog: {
                createTitle: 'Alert',
                cancel: 'Cancel',
                submit: 'Submit',
            },
            commonModule: {
                sendTo: 'Send to',
                self: 'Myself',
                frequency: 'Frequency',
                alertNoUpdate: 'Send an alert even when there are no updates',
                errorEmail: 'The email format entered is incorrect',
                emailToOtherTips: 'Tick this box to confirm you have the consent of the individual whose details you are providing us with.',
            },
        },
        discovery: {

        },
        chemical: {

        },
    },
};
